module.exports = __webpack_public_path__ + "img/01_no.f7a2f852.svg";